import React, { useState } from "react";
import style from './theme.module.sass';
import Sidemenu from "./Sidemenu";
import View from './View';
import { Switch, Route } from "react-router-dom";
import NoData from '../../apps/NoData'
import { ReactComponent as WarningIcon } from '../../../assets/svg/warningIcon.svg'

const Theme: React.FC = props => {

    const [isForbidden, setIsForbidden] = useState(false)

    return (
        !isForbidden ?
        <div className={"row " + style.view}>
            <div className={style.first}>
                <Sidemenu setIsForbidden={setIsForbidden}/>
            </div>
            <div className={style.second}>
              <Switch>
                <Route exact path={"/organization/:orgId/themeManager/:themeId"} component={View} />
              </Switch>
            </div>
        </div>
        :
        <NoData 
            svg={WarningIcon}
            header='Not Authorized'
            content='Please request owner of this organization to provide access' 
            noButton={true}
        />
    )

}

export default Theme
